import { Pipe, PipeTransform } from '@angular/core';
import { LANGUAGES } from 'core/languages';
/*
 * Converts 2 digit country code into long form
 *
 * Example:
 *   {{ 'EN' | languageName }}
 *   formats to: 'English'
*/
@Pipe({name: 'languageName'})
export class LanguageNamePipe implements PipeTransform {
  transform(value: string) {
    const lang = LANGUAGES.find(t => t.value === value);
    return lang ? lang.text : null;
  }
}
